import { useGlobalUser } from "@/stores/globalUser";
import { TextImage } from "@/types/entity1";

export const drawByTextImage = (textImage: TextImage) => {
  window.$router.push({
    name: "imagePaintWithMode",
    query: { textImageId: textImage.uuid, mode: textImage.mode },
  });
};

export const drawByTrait = (textImage: TextImage) => {
  window.$router.push({
    name: "createTraitTask",
    query: { mode: textImage.mode },
  });
};
